enum ETextAlign {
    Center = 'center',
    Justify = 'justify',
    Left = 'left',
    Right = 'right',
}

export { ETextAlign };
